import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchBusinessCategory} from 'sr/utils/api/fetchBusinessCategory'
export const fetchBusinessTypeData = createAsyncThunk(
  'business/fetchBusinessTypeData',
  async (payload: any) => {
    const response = await fetchBusinessCategory({...payload, limit: 1000})
    const data: {type: string; id: string}[] = []
    const idNameMap: {[key: string]: string} = {}
    response.data.forEach((businessType: any) => {
      idNameMap[businessType.id] = businessType.type
      data.push({
        type: businessType.type,
        id: businessType.type,
      })
    })
    return {
      data,
      idNameMap,
    }
  },
  {
    condition: (_payload, { getState }) => {
      const { business } = getState() as { business: { status: string } }
      return business.status !== 'succeeded' && business.status !== 'loading'
    },
  }
)
